import React from 'react'

const ScheduleConsultaion = () => {
  return (
    <div className='container-fluid  schedule-consult'>
       <h2 className='schedule-content'>Discover how our ISO <br /> solutions can transform <br /> your business.</h2>
       <button className="btn btn-light schedule-btn">Schedule Your Consultation</button>
    </div>
  )
}

export default ScheduleConsultaion
